import { DatePipe } from '@angular/common';
import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';
import { parseServerDate } from '../helpers/date-formatting.helper';

/**
 * `date` for server timestamps: `{{ file.modifiedAt | serverDate: 'short' }}`.
 *
 * The server sends UTC `NaiveDateTime` values with no timezone suffix
 * ("2026-10-02T16:00:00"). Angular's `date` pipe reads such a string as local
 * time, so every value showed shifted by the viewer's UTC offset (EHQ-347).
 * This pipe parses through {@link parseServerDate} first, then formats exactly
 * as `date` does, in the viewer's timezone.
 */
@Pipe({ name: 'serverDate' })
export class ServerDatePipe implements PipeTransform {
  readonly #date = new DatePipe(inject(LOCALE_ID));

  transform(
    value: unknown,
    format?: string,
    timezone?: string,
    locale?: string,
  ): string | null {
    return this.#date.transform(parseServerDate(value), format, timezone, locale);
  }
}
